function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#B1C3CC;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  className: "st0",
  d: "M10,10c1.6,0,3-1.4,3-3s-1.4-3-3-3S7,5.3,7,7S8.4,10,10,10z M10,6c0.6,0,1,0.4,1,1s-0.4,1-1,1 S9,7.5,9,7S9.4,6,10,6z M16,14.6c0-2.5-4-3.6-6-3.6s-6,1.1-6,3.6V16h12V14.6z M6.5,14c0.7-0.5,2.2-1,3.5-1s2.8,0.5,3.5,1H6.5z M17,1 H3C1.9,1,1,1.9,1,3v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V3C19,1.9,18.1,1,17,1z M17,17H3V3h14V17z"
});

var SvgLeadProvider = function SvgLeadProvider(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLeadProvider, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lead_provider.ebf376eb.svg";
export { ForwardRef as ReactComponent };